export const RECRUITER_SIGN_IN_REQUEST = 'RECRUITER_SIGN_IN_REQUEST';
export const RECRUITER_SIGN_IN_SUCCESS = 'RECRUITER_SIGN_IN_SUCCESS';
export const RECRUITER_SIGN_IN_FAILURE = 'RECRUITER_SIGN_IN_FAILURE';
export const RECRUITER_SIGN_IN_NEED_CONFIRM = 'RECRUITER_SIGN_IN_NEED_CONFIRM';
